import { supabase } from "../services/supabaseClient";

const SESSION_KEY_PREFIX = "uniair_product_insight_session";

const getSessionId = (productCode) => {
  const key = `${SESSION_KEY_PREFIX}:${productCode}`;

  try {
    const existing = sessionStorage.getItem(key);
    if (existing) return existing;

    const created = crypto.randomUUID();
    sessionStorage.setItem(key, created);
    return created;
  } catch {
    return null;
  }
};

const cleanProperties = (properties = {}) => {
  const blockedKeys = new Set([
    "email",
    "student_email",
    "phone",
    "phone_number",
    "first_name",
    "last_name",
    "name",
    "pickup_location",
    "dropoff_location",
    "pickup_address",
    "dropoff_address",
    "address",
    "notes",
    "flight_number",
    "payment_reference",
    "card_number",
    "id_number",
  ]);

  return Object.fromEntries(
    Object.entries(properties || {}).filter(
      ([key, value]) =>
        !blockedKeys.has(key) &&
        value !== undefined &&
        typeof value !== "function",
    ),
  );
};

/**
 * Non-blocking product analytics.
 *
 * Use this only for events that are not already reliably captured by a
 * database lifecycle trigger. Tracking failures must never stop a booking.
 */
export const trackProductInsightEvent = async ({
  productCode,
  eventName,
  marketId = null,
  entityType = null,
  entityId = null,
  properties = {},
  idempotencyKey = null,
}) => {
  try {
    const { error } = await supabase.rpc(
      "record_insight_product_event_v1",
      {
        p_product_code: productCode,
        p_event_name: eventName,
        p_market_id: marketId,
        p_entity_type: entityType,
        p_entity_id:
          entityId === null || entityId === undefined
            ? null
            : String(entityId),
        p_session_id: getSessionId(productCode),
        p_properties: cleanProperties(properties),
        p_idempotency_key: idempotencyKey,
      },
    );

    if (error) throw error;
  } catch (error) {
    console.warn(
      `[Product Insight] ${productCode}/${eventName} was not recorded:`,
      error,
    );
  }
};
